import { render, staticRenderFns } from "./VirtualScroller.vue?vue&type=template&id=821ed2d2&scoped=true"
import script from "./VirtualScroller.vue?vue&type=script&lang=js"
export * from "./VirtualScroller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821ed2d2",
  null
  
)

export default component.exports